import React, {useEffect, useRef, useState} from 'react';
import CustomButton from "../../../../components/Form/Button";
import {getAffiliates} from "../../../../services/Profile";
import {toast} from "react-toastify";
import * as Yup from "yup";
import messageTypes from "../../../../constants/MessagesTypes";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import {Form} from "@unform/web";
import {AiOutlineSearch} from "react-icons/ai";
import Input from "../../../../components/Form/Input";
import DivDiagonal from "../../../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    FilterSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterRow,
    FilterField,
    FilterButtonWrap,
} from "../../../Trading/styles";
import {
    StrategyPageHeader,
    StrategyWideCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
} from "../../../Strategy/styles";

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    width: 'auto',
    minWidth: 'auto',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
};

export default function Affiliate() {
  const [loadingList, setLoadingList] = useState(false);
  const { t } = useTranslation();
  const [usersAffiliates, setUsersAffiliates] = useState([]);
  const [page, setPage] = useState(1);
  const formRef = useRef(null);
  const [filter, setFilter] = useState({
    stringSearch: '',
  });

  useEffect( () => {
    setLoadingList(true);
    getAffiliates({
      page: page,
      per_page: 25,
      stringSearch: filter.stringSearch,
    }).then((data) => {
      if (!data || data === '') {
        return;
      }

      setUsersAffiliates(data.data);
    }).finally(() => {
      setLoadingList(false);
    });

    return function cleanup() {
      setUsersAffiliates([]);
    };
  }, [page, filter]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function handleSubmit(data) {
    try {

      formRef.current.setErrors({});
      const schema = Yup.object().shape({});

      await schema.validate(data, {
        abortEarly: false,
      });

      setPage(1);
      setFilter({
        stringSearch: data.stringSearch,
      });

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
        toast.warning(messageTypes.REQUIRED_FIELDS);
        return;
      }

      toast.error(messageTypes.ERROR);
    }
  }

    const rowCount = usersAffiliates?.data?.length || 0;

    return (
        <TradingWrapper>
            <DivDiagonal/>
            <ContentArea>
                <StrategyPageHeader>
                    <h1>
                        <i className="fa fa-handshake" aria-hidden="true"/>
                        {' '}{t('admin_affiliates_title')}{' '}
                        <span className="badge">{rowCount}</span>
                    </h1>
                </StrategyPageHeader>

                <StrategyWideCardColumn>
                    <StrategyProductCard>
                        <FilterSection>
                            <StyledFilterFormWrapper>
                                <Form ref={formRef} onSubmit={handleSubmit}>
                                    <FilterTitle>
                                        <i className="fas fa-search"/> {t('filter')}
                                    </FilterTitle>
                                    <FilterRow>
                                        <FilterField>
                                            <Input
                                                type="text"
                                                name="stringSearch"
                                                placeholder={t('admin_affiliates_search_placeholder')}
                                                label={t('admin_affiliates_search_label')}
                                                size={"small"}
                                            />
                                        </FilterField>
                                        <FilterButtonWrap>
                                            <CustomButton
                                                className="btn font-weight-bold text-capitalize mobile-button"
                                                type="submit"
                                                startIcon={<AiOutlineSearch/>}
                                                style={filterSearchBtnStyle}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                }}
                                            >
                                                {t('filter_btn_submmit')}
                                            </CustomButton>
                                        </FilterButtonWrap>
                                    </FilterRow>
                                </Form>
                            </StyledFilterFormWrapper>
                        </FilterSection>

                        <StrategyTableWrapper>
                            {loadingList ? (
                                <StrategyLoadingButton
                                    className="btn btn-primary text-capitalize font-weight-bold"
                                    loading={loadingList}
                                    type="button"
                                >
                                    {t('loading')}
                                </StrategyLoadingButton>
                            ) : (
                                <>
                                    {usersAffiliates && usersAffiliates.data && usersAffiliates.data.length ? (
                                        <>
                                        {/* Mobile: cards */}
                                        <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'column', gap: 1.5, pt: 1.5, pb: 1 }}>
                                            {usersAffiliates.data.map((row) => (
                                                <Box key={row.id} sx={{ borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.04)', px: 2, py: 1.5 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
                                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                                            <span style={{ display: 'block', fontWeight: 600, color: '#e0e0e0', fontSize: '0.95rem' }}>{row.name}</span>
                                                            <span style={{ display: 'block', color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', marginTop: 2 }}>{row.email}</span>
                                                        </Box>
                                                        <Box sx={{ flexShrink: 0, textAlign: 'right' }}>
                                                            <span style={{ display: 'block', color: 'rgba(255,255,255,0.45)', fontSize: '0.72rem' }}>{t('admin_affiliates_col_affiliate_id')}</span>
                                                            <span style={{ display: 'block', fontWeight: 600, color: '#f29205', fontSize: '0.85rem' }}>{row.affiliateID}</span>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                                                        <small style={{ color: 'rgba(255,255,255,0.45)' }}>{t('admin_affiliates_created')}: {new Date(row.created.date).toLocaleDateString()}</small>
                                                        <small style={{ color: 'rgba(255,255,255,0.65)' }}>{row.qtdReferredUsers} {t('admin_affiliates_col_referred_count').toLowerCase()}</small>
                                                    </Box>
                                                </Box>
                                            ))}
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, paddingTop: 8, borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 4 }}>
                                                <StrategyPaginationInfo>{t('table_pagination_text', { page, totalPage: usersAffiliates.total_page + 1 })}</StrategyPaginationInfo>
                                                <div style={{ display: 'flex', gap: 8 }}>
                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}><IoIosArrowBack/> {t('table_pagination_back')}</StrategyPaginationButton>
                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!usersAffiliates.next_page}>{t('table_pagination_next')} <IoIosArrowForward/></StrategyPaginationButton>
                                                </div>
                                            </div>
                                        </Box>

                                        {/* Desktop: tabela */}
                                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                        <StrategyTableContainer>
                                            <Table aria-label={t('admin_affiliates_title')}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>{t('admin_affiliates_col_user_id')}</TableCell>
                                                        <TableCell>{t('admin_affiliates_col_email')}</TableCell>
                                                        <TableCell align="center">{t('admin_affiliates_col_affiliate_id')}</TableCell>
                                                        <TableCell align="center">{t('admin_affiliates_col_referred_count')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {usersAffiliates.data.map((row) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell>
                                                                {(row.id).split('-')[0]}
                                                                <br/>
                                                                <small style={{ color: 'rgba(255,255,255,0.45)' }}>{t('admin_affiliates_created')}: {new Date(row.created.date).toLocaleDateString()}</small>
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.name}
                                                                <br/>
                                                                <small style={{ color: 'rgba(255,255,255,0.45)' }}>{row.email}</small>
                                                            </TableCell>
                                                            <TableCell align="center">{row.affiliateID}</TableCell>
                                                            <TableCell align="center">{row.qtdReferredUsers}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TableCell colSpan={4}>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                                                                <StrategyPaginationInfo>{t('table_pagination_text', { page, totalPage: usersAffiliates.total_page + 1 })}</StrategyPaginationInfo>
                                                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page - 1)} disabled={page <= 1}><IoIosArrowBack/> {t('table_pagination_back')}</StrategyPaginationButton>
                                                                    <StrategyPaginationButton type="button" onClick={() => setPage(page + 1)} disabled={!usersAffiliates.next_page}>{t('table_pagination_next')} <IoIosArrowForward/></StrategyPaginationButton>
                                                                </div>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </StrategyTableContainer>
                                        </Box>
                                        </>
                                    ) : (
                                        <StrategyEmptyState>
                                            <i className="fa fa-handshake" aria-hidden="true"/>
                                            <p>{t('admin_affiliates_empty_title')}</p>
                                            <span>{t('admin_affiliates_empty_subtitle')}</span>
                                        </StrategyEmptyState>
                                    )}
                                </>
                            )}
                        </StrategyTableWrapper>
                    </StrategyProductCard>
                </StrategyWideCardColumn>
            </ContentArea>
        </TradingWrapper>
    );
}
